import React from "react";
import { Row, Col, Container } from "react-bootstrap";

import GlassTimeMachineFamilyListCustomer from './GlassTimeMachineFamilyListCustomer.js'
import GlassTimeCustomerListCustomer from './GlassTimeCustomerListCustomer.js';
import GlassTimeSnMachineListCustomer from './GlassTimeSnMachineListCustomer.js';
import GlassTimeDateRangeSelectorCustomer from './GlassTimeDateRangeSelectorCustomer.js';
import GlassTimeStartAnalysisCustomer from './GlassTimeStartAnalysisCustomer.js';

import { useGlobalState } from '../../components/globalStateProvider.js';


// MAIN PAGE
function AnalisiTempoVetrinoClientePage() {    
    
    const { machineFamilyGlassTimeCustomer, listCustomerGlassTimeCustomer, customerNameGlassTimeCustomer, 
            listSNMachinesGlassTimeCustomer, snMachineGlassTimeCustomer
        } = useGlobalState();

    return (
        <div>
            <Container>
                <Row className="text-center mt-4 mb-4">
                    <h2>Analisi tempo apertura vetrino cliente</h2>
                        <p className="mt-1">Questa sezione presenta una panoramica dei tempi di apertura vetrino del cliente selezionato nel periodo prendendo come riferimento l'errore di cassetto porta vetrino.
                        </p>
                </Row>

                <Row>
                    <Col md={{span:6, offset:3}}>
                        <GlassTimeMachineFamilyListCustomer/>
                        {machineFamilyGlassTimeCustomer !== 0 && machineFamilyGlassTimeCustomer !== "0" && listCustomerGlassTimeCustomer.length > 0 && <GlassTimeCustomerListCustomer />}
                        {machineFamilyGlassTimeCustomer !== 0 && machineFamilyGlassTimeCustomer !== "0" && customerNameGlassTimeCustomer !== "" && listSNMachinesGlassTimeCustomer.length > 0 && <GlassTimeSnMachineListCustomer />}
                    </Col>
                </Row>

                <Row>
                    <Col md={{span:4, offset:4}}>
                        {machineFamilyGlassTimeCustomer !== 0 && customerNameGlassTimeCustomer !== "" && listSNMachinesGlassTimeCustomer.length > 0 && snMachineGlassTimeCustomer !== "" && <GlassTimeDateRangeSelectorCustomer />}
                    </Col>
                    <GlassTimeStartAnalysisCustomer />
                </Row>
            </Container>        
        </div>
    );
}

export default AnalisiTempoVetrinoClientePage;